import { render } from "./ScanRegisteredOtherMerchantView.vue?vue&type=template&id=f4829d04&scoped=true&lang=true"
import script from "./ScanRegisteredOtherMerchantView.vue?vue&type=script&lang=js"
export * from "./ScanRegisteredOtherMerchantView.vue?vue&type=script&lang=js"

import "./ScanRegisteredOtherMerchantView.vue?vue&type=style&index=0&id=f4829d04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4829d04"]])

export default __exports__